// The client's old Jira host(s), asked once per page load.
//
// A paste is synchronous, so the answer has to be in hand before it: the
// first editor to mount asks (GET /api/smart-links/config) and every paste
// after reads the cached list. Until it arrives — or if it fails — the list
// is empty and an old Jira address pastes as it always did.

import api from '@app/services/api';

let hosts = [];
let asked = false;

export function loadSmartLinkConfig() {
  if (asked) return;
  asked = true;
  api.getSmartLinkConfig()
    .then((cfg) => { hosts = Array.isArray(cfg?.legacyJiraHosts) ? cfg.legacyJiraHosts : []; })
    .catch(() => { asked = false; }); // ask again on the next editor
}

export function legacyJiraHosts() {
  return hosts;
}
